var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpaStone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25195 30.9612C3.56782 30.9596 2.90272 30.7359 2.35666 30.3238C1.8106 29.9116 1.4131 29.3334 1.22395 28.6759C0.199952 25.1252 2.23062 19.1572 16 19.1572C29.8786 19.1572 31.8293 25.2226 30.748 28.7639C30.5501 29.4123 30.1489 29.9798 29.6036 30.3825C29.0583 30.7851 28.3978 31.0016 27.72 30.9999L4.25195 30.9612Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4332 19.1801C25.9452 19.1494 28.2332 18.2254 28.2332 15.7134C28.2332 13.1627 25.8652 9.94141 16.9838 9.94141C8.10249 9.94141 5.73315 13.1681 5.73315 15.7187C5.73315 18.0814 7.76782 19.0387 15.1278 19.1667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4667 9.95089C23.1587 9.80289 24.7533 8.97489 24.7533 7.01756C24.7533 4.83756 22.78 2.08423 15.3787 2.08423C7.97733 2.08423 6 4.8349 6 7.0149C6 9.1949 7.97333 9.97623 15.3747 9.97623H15.6107",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaStone);
export default __webpack_public_path__ + "static/media/SpaStone.89c30630479babf965237639cf628d16.svg";
export { ForwardRef as ReactComponent };